import { InfoDto } from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction, useSuspenseQuery } from '@tanstack/react-query';

import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

const fetchTenantInfo: QueryFunction<InfoDto> = async () => {
  const res = await portalGatewayClient.tenant.getInfo();
  if (res.ok) {
    return res.data.data;
  }

  throw new HttpError('Fetching tenant info failed.', res);
};

export function useTenantInfoData() {
  return useSuspenseQuery({
    queryKey: ['tenantInfo'],
    queryFn: fetchTenantInfo,
    gcTime: Infinity,
  });
}
